/**
 * useDRE — fetcha /api/dre/summary (DRE mensal embutido na dashboard).
 *
 * Retorna { data, loading, error, refetch }. Re-busca quando `year` ou cliente
 * mudam. Espelha useSEO/useDashboard (proteção anti-stale via requestId).
 */

import { useState, useEffect, useCallback, useRef } from 'react'
import { getDRE, setSelectedClientId } from '../db/api.js'

export function useDRE(year, clientId, granularity = 'month') {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const requestIdRef = useRef(0)

  const refetch = useCallback(async () => {
    const requestId = ++requestIdRef.current
    setLoading(true)
    setError(null)
    try {
      setSelectedClientId(clientId)
      const result = await getDRE(year, granularity)
      if (requestId !== requestIdRef.current) return
      setData(result)
    } catch (err) {
      if (requestId !== requestIdRef.current) return
      console.error('[useDRE] fetch error:', err)
      setError(err.message || 'Erro ao carregar DRE')
    } finally {
      if (requestId === requestIdRef.current) setLoading(false)
    }
  }, [year, clientId, granularity])

  useEffect(() => { refetch() }, [refetch])

  return { data, loading, error, refetch }
}
